export const SUBSCRIPTION_TYPE = [
  {
    label: "Next Send Reminder",
    value: "next_send",
  },
  {
    label: "First Reminder",
    value: "first_call",
  },
  {
    label: "Second Reminder",
    value: "second_call",
  },
  {
    label: "Third Reminder",
    value: "third_call",
  },
  {
    label: "Letter",
    value: "letter",
  },
];
